<template>
	<div class="">
		<div class="search-box common-class">
			<div class="search-item" :class="{ 'search-item-date': item.type == 3 }" v-for="item in searchData">
				<div class="search-des">{{item.name}}：</div>
				<template v-if="!item.type">
					<el-input v-model="item.content" :placeholder="`请输入${item.name}`"></el-input>
				</template>
				<template v-if="item.type == 1">
					<el-select v-model="item.content"  placeholder="请选择" :multiple='item.multiple'>
						<el-option
						  v-for="(item2,index) in item.options"
						  @click.native ="change(item,index)"
						  :key="index"
						  :label="item.porpLabel ? item2[item.porpLabel] : item2.label"
						  :value="item.porpValue ? item2[item.porpValue] : item2.value"
						  >
						</el-option>
					  </el-select>
				</template>
				<template v-if="item.type == 2">
					<el-cascader
					    :options="item.options"
					    :props="{ checkStrictly: true }"
					    clearable></el-cascader>
				</template>
				<template v-if="item.type == 3">
					<el-date-picker v-model="item.content" :type="item.dateType" :picker-options="datePickerOptions[item.pickerOptions]"
					 :clearable='false' :disabled="item.disabled" :default-time="item.defaultTime" :placeholder="getPlaceholder(item)"
					 start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
				</template>
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			searchData : ''
		},
		data() {
			return {
				switchState : true,
				datePickerOptions : {
					
				}
			}
		},
		methods: {
			getPlaceholder(row) {
				let placeholder
				if (row.type === 'input' || row.type === 'textarea') {
					placeholder = '请输入' + row.name
				} else if (row.type === 'select' || row.type === 'time' || row.type === 'date') {
					placeholder = '请选择' + row.name
				} else {
					placeholder = row.name
				}
				return placeholder
			},
			change(item,index){
				if(item.key == "group" && item.options[index].code){
					this.searchData[2].content = ''
					this.searchData[2].options = this.searchData[2].options2.filter(item2=> item2.parentCode == item.options[index].code)
				}
				if(item.key == "group" && !item.options[index].code){
					this.searchData[2].content = ''
					this.searchData[2].options = this.searchData[2].options2
				}
			},
			toggle(){
				this.switchState = !this.switchState
			}
		},
		mounted(){
			
		}
	}
</script>

<style scoped lang="scss">
	.search-box {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 0;
		align-items: center;
	
		.search-item {
			min-width: 1.302083rem;
			margin-right: 0.15625rem;
			margin-bottom: 0.104166rem;
	
			.el-input {
				width: 100%;
			}
	
			.el-select {
				width: 100%;
			}
	
			.search-des {
				margin-bottom: 0.052083rem;
			}
	
			input {
				height: 0.166666rem;
			}
			.el-input__icon {
				line-height: 0.166666rem;
			}
		}

		.search-item-date {
			min-width: 1.822916rem;
			flex-shrink: 0;

			.el-date-editor {
				width: 100%;
			}
		}
	}
</style>
